import React, {useState} from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Wrapper from "../Wrappers/Wrapper";
import {FormContainer, StyledCheckbox, StyledRadio} from "./FormStyles";
import TurnstileWidget from "./TurnstileWidget";

const RestaurantTableReservation = () => {
  const [date, setDate] = useState('');

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  const siteUrl = data.site.siteMetadata.siteUrl;
  const today = new Date().toISOString().split('T')[0];

  return (
    <FormContainer>
      <Wrapper style={{ marginBottom: 50 }}>
        <h2>Tischreservation Restaurant</h2>
        <form action={process.env.GATSBY_GOEASTFORM_FORM_ACTION} method="POST">
          <input type="hidden" name="subject" value="Tischreservation Restaurant"/>
          <input type="hidden" name="recipient"
                 value={process.env.GATSBY_GOEASTFORM_RECIPIENT_TABLE_RESERVATION || ''}/>
          <input type="hidden" name="redirect" value={`${siteUrl}/form-sent`}/>
          <input type="hidden" name="missing" value={`${siteUrl}/form-missing`}/>
          <input type="hidden" name="required" value="Name_Vorname,Datum,Tischreservation,email"/>

          <div className="form-group">
            <div>
              <label htmlFor="tischreservation_date">Datum</label>
            </div>
            <input
              type="date"
              id="tischreservation_date"
              name="Datum"
              value={date}
              onChange={(e) => {
                setDate(e.target.value)
              }}
              min={today}
              required
            />

            <div style={{marginTop: 15}}>
              <label><StyledRadio type="radio" name="Tischreservation" value="Mittagessen um 12:15 Uhr"
                                  required/> Mittagessen um 12:15 Uhr</label><br/>
              <label><StyledRadio type="radio" name="Tischreservation" value="Abendessen um 17:30 Uhr"
                                  required/> Abendessen um 17:30 Uhr</label><br/>
            </div>
          </div>

          <div className="form-group">
            <div className="form-input">
              <label htmlFor="name_lastname">Name und Vorname *</label>
              <input type="text" id="name_lastname" name="Name_Vorname" required/>
            </div>
            <div className="form-input">
              <label htmlFor="bewohner">Name und Vorname Bewohner/in</label>
              <input type="text" id="bewohner" name="Bewohner"/>
            </div>
          </div>

          <div className="form-group">
            <div className="form-input">
              <label htmlFor="email">E-mail *</label>
              <input type="text" id="email" name="email" required/>
            </div>
          </div>

          <div className="form-group">
            <div style={{marginBottom: 15}}>Pflegewohnabteilung</div>
            <label><StyledRadio type="radio" name="PWA" value="PWA 1"/> PWA 1</label><br/>
            <label><StyledRadio type="radio" name="PWA" value="PWA 2"/> PWA 2</label><br/>
            <label><StyledRadio type="radio" name="PWA" value="PWA 3"/> PWA 3</label><br/>
            <label><StyledRadio type="radio" name="PWA" value="PWA 4"/> PWA 4</label>
          </div>

          <div className="form-input">
            <label htmlFor="number_of_guests">Anzahl Personen (inkl. Bewohner/in)</label>
            <input type="text" id="number_of_guests" name="Anzahl_der_Gäste"/>
          </div>

          <div className="form-group" style={{marginTop: 25}}>
            <div style={{marginBottom: 15}}>Allergien</div>
            <label><StyledCheckbox type="checkbox" name="Allergie_Zoeliakie" value="Ja"/> Zöliakie
              (glutenfrei)</label><br/>
            <label><StyledCheckbox type="checkbox" name="Allergie_Laktose"
                                   value="Ja"/> Lactose-Intoleranz</label><br/>
            <label><StyledCheckbox type="checkbox" name="Allergie_Nuss" value="Ja"/> Nuss-Allergie</label><br/>
            <label><StyledCheckbox type="checkbox" name="Allergie_Sellerie" value="Ja"/> Sellerie</label><br/>
            <label><StyledCheckbox type="checkbox" name="Allergie_Sulfide" value="Ja"/> Sulfide</label><br/>
            <label><StyledCheckbox type="checkbox" name="Allergie_Soja" value="Ja"/> Soja</label><br/>
            <label><StyledCheckbox type="checkbox" name="Allergie_Eier" value="Ja"/> Eier</label><br/>
            <label><StyledCheckbox type="checkbox" name="Allergie_Fisch" value="Ja"/> Fisch +
              Fischerzeugnisse</label><br/>
            <label><StyledCheckbox type="checkbox" name="Allergie_Senf" value="Ja"/> Senf</label><br/>
            <label><StyledCheckbox type="checkbox" name="Allergie_Sesam" value="Ja"/> Sesam</label>
          </div>

          <div className="form-group">
            <label htmlFor="bemerkungen">Bemerkungen:</label>
            <textarea id="bemerkungen" name="Bemerkungen" rows={10}></textarea>
          </div>

          <TurnstileWidget siteKey={process.env.GATSBY_GOEASTFORM_TURNSTILE_SITE_KEY || ''}/>

          <button type="submit">Absenden</button>
        </form>
      </Wrapper>
    </FormContainer>
);
};

export default RestaurantTableReservation;